import { MMGatewayClient } from '../MMGatewayClient';
import type {
  IAddressAttributes,
  IAddressListResponse,
  ICreateCustomerAddress,
  ICustomerAddressResponse,
  IUpdateAddressData,
} from './models';

const ADDRESS_TYPE = 'customer_address';
const ADDRESSES_MAX_COUNT = 100;
const ADD_ADDRESS_GEO_PROVIDER = 'yandex_map';

class _CustomerAddressesClient extends MMGatewayClient {
  public async getAddressBook() {
    return this.get<IAddressListResponse>(
      `customer_addresses/v1/address_book?page_size=${ADDRESSES_MAX_COUNT}`
    );
  }

  public async addAddress(attributes: IAddressAttributes) {
    attributes.geoProvider = ADD_ADDRESS_GEO_PROVIDER;
    const payload: ICreateCustomerAddress = {
      data: { type: ADDRESS_TYPE, attributes },
    };

    return this.post<{ data: ICustomerAddressResponse }, ICreateCustomerAddress>(
      'customer_addresses/v1/address_book',
      payload
    ).then((r) => r.data);
  }

  public async deleteAddress(addressId: string) {
    return this.delete(`customer_addresses/v1/address_book/${addressId}`);
  }

  public async patchAddress(data: IUpdateAddressData) {
    return this.patch<{ data: ICustomerAddressResponse }, { data: IUpdateAddressData }>(
      `customer_addresses/v1/address_book/${data.id}`,
      { data }
    ).then((r) => r.data);
  }
}

export const CustomerAddressesClient = new _CustomerAddressesClient();
